import { render, staticRenderFns } from "./AlertsDialog.vue?vue&type=template&id=401f176f&"
import script from "./AlertsDialog.vue?vue&type=script&lang=js&"
export * from "./AlertsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports